<template>
  <div>
  </div>
</template>
<script>
  export default {
    name: 'PaymentYapaySigin',
    methods: {
      showLoader () {
        this.$loader.show()
      },
      saveSession () {
        window.sessionStorage.setItem('subdomain', this.$route.params.subdomain)
        window.sessionStorage.setItem('identifier', this.$route.params.id)
        this.redirectToYapayLogin()
      },
      redirectToYapayLogin () {
        window.location.href = process.env.URL_YAPAY_LOGIN
      }
    },
    mounted () {
      this.showLoader()
      this.saveSession()
    }
  }
</script>


// WEBPACK FOOTER //
// PaymentYapaySignin.vue?313b2a18